/*
 * Local dev helper — set REACT_APP_DISABLE_AUTH_REDIRECT=true in .env
 * to skip auth/onboarding redirects (.env is gitignored).
 * Do not enable in production.
 */
export function isAuthRedirectDisabled() {
  return process.env.REACT_APP_DISABLE_AUTH_REDIRECT === "true";
}

export function logSkippedAuthRedirect(reason, target) {
  console.warn(
    `[Auth redirect disabled] Skipped ${reason}.`,
    target ? { target } : ""
  );
}
